"use strict";
// ── Ticket Types ───────────────────────────────────────────────────────
// Moved from Trackly.WebClient/src/services/TicketService/types.ts (T011).
// Consolidated from ticketTypes.ts, ticketWorklistTypes.ts, documentTypes.ts
Object.defineProperty(exports, "__esModule", { value: true });
